// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const LuggageBikeCover = svgLazyLoader('luggage/luggage_bike_cover')
const LuggageLarge = svgLazyLoader('luggage/luggage_large')
const LuggageMedium = svgLazyLoader('luggage/luggage_medium')
const LuggageSmall = svgLazyLoader('luggage/luggage_small')

const ALL_LUGGAGE_ICONS = ['luggage_bike_cover', 'luggage_large', 'luggage_medium', 'luggage_small'] as const
export type LuggageIcon = (typeof ALL_LUGGAGE_ICONS)[number]

const ICONS: LazyIconsGroup<LuggageIcon> = {
  luggage_bike_cover: LuggageBikeCover,
  luggage_large: LuggageLarge,
  luggage_medium: LuggageMedium,
  luggage_small: LuggageSmall,
}

export const isLuggageIcon = (luggageKey: string): luggageKey is LuggageIcon =>
  ALL_LUGGAGE_ICONS.includes(luggageKey as LuggageIcon)

export const getLuggageIcon = (luggageKey: LuggageIcon): LazyIcon => ICONS[luggageKey]

export const getLuggageIcons = (): LazyIconsGroup<LuggageIcon> => ICONS
